import { DateFieldValue } from "./DateFieldSubMenu.tsx";
import { NumberIntervalValue } from "./NumberFieldSubMenu.tsx";
import { AmountFieldValue } from "./AmountFieldSubMenu.tsx";
import { RecurrenceFieldValue } from "./RecurrenceFieldSubMenu.tsx";
import { isNullOrWhitespace } from "../../../stringOperations.ts";

export function GetDateData(value: any): DateFieldValue {
    return typeof value === "string" && value ? JSON.parse(value) : ((value || { from: undefined, to: undefined, dateFieldEnum: undefined }) as DateFieldValue);
}

export function GetNumberData(value: any): NumberIntervalValue {
    return typeof value === "string" && value ? JSON.parse(value) : ((value || { from: undefined, to: undefined }) as NumberIntervalValue);
}

export function GetAmountData(value: any): AmountFieldValue {
    return typeof value === "string" && value ? JSON.parse(value) : ((value || { currencyCode: "", from: undefined, to: undefined }) as AmountFieldValue);
}

export function GetListData(value: any): Array<string> {
    let chosenValues: Array<string> = [];
    if (Array.isArray(value)) {
        chosenValues = value;
    } else if (!isNullOrWhitespace(value)) {
        chosenValues = JSON.parse(value);
    }

    return chosenValues;
}

export function GetRecurrenceData(value: any): RecurrenceFieldValue {
    return typeof value === "string" && value
        ? JSON.parse(value)
        : ((value || { from: undefined, to: undefined, recurrenceFilterEnum: undefined }) as RecurrenceFieldValue);
}

export function GetBooleanData(value: any): string | undefined {
    return value === undefined || value === null || value === "" ? undefined : value ? "1" : "0";
}
